export enum ENonProdEnvs {
  DEV = 'dev',
  QA = 'qa',
  UAT = 'uat',
}
